import { PreloadingStrategy, Route } from '@angular/router'
import { Observable, of, switchMap, timer } from 'rxjs'

/**
 * Preloading für alle componenten bei denen preloadDelay gesetzt ist.
 */
export class AppPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    const { data } = route
    const preloadDelay = data?.['preloadDelay']
    if (preloadDelay !== undefined) {
      return timer(preloadDelay).pipe(switchMap(() => load()))
    }
    return of(null)
  }
}
